import './LandingPage.css';
import {useLocation} from 'react-router-dom';
import cx from 'classnames';
import React, {Suspense, useEffect} from 'react';
import HeroBannerSection from './HeroBannerSection/HeroBannerSection';
import {BenefitsOfPrequalSection} from './BenefitsOfPrequalSection/BenefitsOfPrequalSection';
import {ReadyToBuySection} from './ReadyToBuySection/ReadyToBuySection';
import {tagGetPrequalifyButtonClick, tagLandingPageView} from '../../Services/TaggingService/TaggingService';
import {LandingPageFaqDropdownValues} from '../../assets/faq/FAQDropDownValues';
import SpecialEventBannerSection from '../../components/SpecialEvent/SpecialEventBannerSection/SpecialEventBannerSection';
import AppModalDialog from '../../components/AppModalDialog/AppModalDialog';
import RenderPage from '../../RenderPage';
import {AccordionPanel} from '../../components/Accordion/AccordionPanel';
import {resetCustomerData, updateShowModalFlag} from '../../redux/app-state-slice';
import {SPECIAL_EVENT_PAGE_NAME} from '../../utils/constants/constants';

export function LandingPage({appConfig, customerData, dispatch}) {
  const {state, pathname} = useLocation();
  const {isFromApply = false} = state || {};
  useEffect(() => {
    const onPageLoad = () => {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const startState = params.get('start');
      if (document.readyState === 'complete') {
        if (startState === 'apply' || isFromApply) {
          getPrequalified(true);
        } else {
          tagLandingPageView(
            pathname.toLowerCase().includes(SPECIAL_EVENT_PAGE_NAME.toLowerCase()),
            appConfig.countryCode,
            customerData.languageCode
          );
        }
      }
    };
    window.addEventListener('load', onPageLoad, false);
    return () => window.removeEventListener('load', onPageLoad, false);
  }, [document.readyState]);

  const getContent = () => (
    <Suspense fallback={<div>Loading...</div>}>
      <div id='prequal--web--app'>
        <main className='prequal--web--app prequal--wc--app'>
          <div className='prequal--web--form-container'>
            <RenderPage appConfig={appConfig} customerData={customerData} dispatch={dispatch} />
          </div>
        </main>
      </div>
    </Suspense>
  );

  const getPrequalified = (isApply = false) => {
    dispatch(resetCustomerData(customerData));
    const vehicleChooserFlagInfo = {isEnabled: false, variationKey: ''};
    dispatch(updateShowModalFlag(true));
    if (!isApply) {
      tagGetPrequalifyButtonClick(vehicleChooserFlagInfo, customerData.specialEvent.value);
    }
  };

  return (
    <>
      <div className='prequal--web-ford-motion-landing-page-container'>
        {customerData.showModalFlag.value && (
          <Suspense fallback={<div>Loading...</div>}>
            <AppModalDialog content={() => getContent()} customerData={customerData} appConfig={appConfig} />
          </Suspense>
        )}
        {customerData.specialEvent.value ? (
          <SpecialEventBannerSection getPrequalified={getPrequalified} event={SPECIAL_EVENT_PAGE_NAME} />
        ) : (
          <HeroBannerSection getPrequalified={getPrequalified} countryCode={appConfig.countryCode} />
        )}
        <BenefitsOfPrequalSection getPrequalified={getPrequalified} />
        <ReadyToBuySection appConfig={appConfig} customerData={customerData} />
        <div className={cx('prequal--web--landingpage-faq-container-outer')}>
          <AccordionPanel
            accordionDropDownValues={LandingPageFaqDropdownValues(customerData)}
            accordionTitle='Frequently Asked Questions'
          />
        </div>
      </div>
    </>
  );
}
